import {
  HIDE_MESSAGE,
  INIT_URL,
  ON_HIDE_LOADER,
  ON_SHOW_LOADER,
  SHOW_MESSAGE,
  SIGNIN_FACEBOOK_USER_SUCCESS,
  SIGNIN_GITHUB_USER_SUCCESS,
  SIGNIN_GOOGLE_USER_SUCCESS,
  SIGNIN_TWITTER_USER_SUCCESS,
  SIGNIN_USER_SUCCESS,
  SIGNOUT_USER_SUCCESS,
  SIGNUP_USER_SUCCESS,
  AGENT_MODE,
  LIST,
  QHOME,
  QRESERVE,
  POSITION,
  LISTRESERVE,
  POSITIONRESERVE,
  SHARETOKEN,
  DAMANE,UPDATE,
  PWA,
  INSTALLMESSAGE
} from "constants/ActionTypes";

const INIT_STATE = {
  loader: false,
  alertMessage: '',
  showMessage: false,
  agentMode:false,
  list : [],
  position : 0,
  sharetoken:'',
  qhome:'',
  qreserve:'',
  listreserveredux : [],
  positionreserve : 0,
  initURL: '',
  damane:'',
  pwa:false,
  installmessage:localStorage.getItem('showinstall'),update:localStorage.getItem('update'),
  authUser: localStorage.getItem('user_id'),
};


export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case SIGNUP_USER_SUCCESS: {
      return {
        ...state,
        loader: false,
        authUser: action.payload
      }
    }
    case SIGNIN_USER_SUCCESS: {
      return {
        ...state,
        loader: false,
        authUser: action.payload
      }
    }
    case INIT_URL: {
      return {
        ...state,
        initURL: action.payload
      }
    }
    case SIGNOUT_USER_SUCCESS: {
      return {
        ...state,
        authUser: null,
        initURL: '/app/dashboard/crypto',
        loader: false
      }
    }

    case SHOW_MESSAGE: {
      return {
        ...state,
        alertMessage: action.payload,
        showMessage: true,
        loader: false
      }
    }
    case HIDE_MESSAGE: {
      return {
        ...state,
        alertMessage: '',
        showMessage: false,
        loader: false
      }
    }

    case SIGNIN_GOOGLE_USER_SUCCESS: {
      return {
        ...state,
        loader: false,
        authUser: action.payload
      }
    }
    case SIGNIN_FACEBOOK_USER_SUCCESS: {
      return {
        ...state,
        loader: false,
        authUser: action.payload
      }
    }
    case SIGNIN_TWITTER_USER_SUCCESS: {
      return {
        ...state,
        loader: false,
        authUser: action.payload
      }
    }
    case SIGNIN_GITHUB_USER_SUCCESS: {
      return {
        ...state,
        loader: false,
        authUser: action.payload
      }
    }
    case ON_SHOW_LOADER: {
      return {
        ...state,
        loader: true
      }
    }
    case ON_HIDE_LOADER: {
      return {
        ...state,
        loader: false
      }
    }
    case AGENT_MODE: {
      return {
        ...state,
        agentMode: action.payload
      }
    }
    case LIST: {
      return {
        ...state,
        list: action.payload
      }
    }
    case POSITION: {
      return {
        ...state,
        position: action.payload
      }
    }

    case QHOME: {
      return {
        ...state,
        qhome: action.payload
      }
    }

    case QRESERVE: {
      return {
        ...state,
        qreserve: action.payload
      }
    }

    case LISTRESERVE: {
      return {
        ...state,
        listreserveredux: action.payload
      }
    }
    case POSITIONRESERVE: {
      return {
        ...state,
        positionreserve: action.payload
      }
    }
    case SHARETOKEN: {
      return {
        ...state,
        sharetoken: action.payload
      }
    }
    case DAMANE: {
      return {
        ...state,
        damane: action.payload
      }
    }
    case UPDATE: {
      return {
        ...state,
        update: action.payload
      }
    }
    case PWA: {
      return {
        ...state,
        pwa: action.payload
      }
    }
    case INSTALLMESSAGE: {
      return {
        ...state,
        installmessage: action.payload
      }
    }

    default:
      return state;
  }
}
